var map = {
	"./ai-video-template/en.json": [
		7652,
		3173
	],
	"./pix/en.json": [
		12376,
		3173
	],
	"./pricing/en.json": [
		64697,
		3173
	],
	"./veo3/en.json": [
		4110,
		3173
	],
	"./video-generator/en.json": [
		1846,
		3173
	],
	"./videocard/en.json": [
		36180,
		3173
	],
	"./wan22/en.json": [
		73621,
		3173
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12339;
module.exports = webpackAsyncContext;